var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Stacker, TypographyBody, Score } from '@honeycomb/ui-core';
import { formatCustomerRating } from '../utils';
export function HotelCustomerRating(_a) {
    var { overallRating, overallRatingDescription, onClick } = _a, other = __rest(_a, ["overallRating", "overallRatingDescription", "onClick"]);
    return (React.createElement(Stacker, Object.assign({ direction: "row", spacing: 2, alignItems: "center", button: true, onClick: (event) => {
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
        } }, other),
        React.createElement(Score, { color: "primary", size: "xs", "data-id": "review-rating" }, formatCustomerRating(overallRating)),
        overallRatingDescription && (React.createElement(TypographyBody, { size: "s", color: "text.heading" }, overallRatingDescription))));
}
